import React, {useState, useEffect} from 'react'
import { Row, Col, Image, Form, Button } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import Card from '../components/Card'
import { useAuth } from '../components/auth/AuthProvider';
import axios from 'axios';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useLanguage } from '../i18n/LanguageContext';
import Logo from '../components/partials/components/logo';
import AuthDecor from '../components/AuthDecor';
import apiUrl from '../config/api';

// img
import auth1 from '../assets/images/auth/01.png'

const SignIn = () => {
   let navigate = useNavigate()
   const AuthProvider = useAuth();
   const { t } = useLanguage();
   //console.log("Authenticated:", AuthProvider.isAuthenticated);
   
   useEffect(()=>{
      if (AuthProvider.isAuthenticated){
         navigate("/dashboard");
      }
   }, [AuthProvider.isAuthenticated, navigate]);

   const { loginMe } = useAuth();

   const [formData, setFormData] = useState({
      email: '',
      password: '',
      remember: false,
   });

   const handleChange = (e) => {
      const { name, value, type, checked } = e.target;
      setFormData({
        ...formData,
        [name]: type === 'checkbox' ? checked : value,
      });
   };

   const handleSubmit = async (e) => {
      e.preventDefault();
      //alert(`${apiUrl}/login`);
      //alert(typeof `${apiUrl}/login`);
      try{
         await axios.post(`${apiUrl}/login`, formData, {
            withCredentials: true,
            skipAuthRefresh: true,
            skipAuthToken: true,
         })
         .then(function (response) {
            if(response.status === 201){
               loginMe(response.data.user, response.data.accessToken || response.data.token);
            }
         })
         .catch(function (error) {
            console.log(error);
            if (!error.response) {
               alert(`${t.auth.requestError} ${error.message}`);
               return;
            }

            const message = error.response?.data?.message || error.message;
            alert(`${t.auth.invalidCredentials} ${message}`);
         });
      } catch (error) {
         // Controlla se error.response esiste
         if (error.response) {
             // Il server ha risposto con uno status diverso da 2xx
             alert(`${t.auth.responseError} ${error.response.data?.message || ''}`);

             if (error.response.data) {
               alert(error.response.data.message);
             }
         } else if (error.request) {
             // La richiesta è stata fatta, ma non c'è stata alcuna risposta
             alert(`${t.auth.requestError} ${error.request}`);
         } else {
             // Altro tipo di errore durante la creazione della richiesta
             alert(`${t.auth.genericError} ${error.message}`);
         }
     }
   };

   if (AuthProvider.isAuthLoading) {
      return null;
   }

   return (
      <>
         <section className="login-content">
            <Row className="m-0 align-items-center bg-white vh-100">
               <Col md="6">
                  <div className="auth-language-switcher">
                     <LanguageSwitcher placement="auth" />
                  </div>
                  <Row className="justify-content-center">
                     <Col md="10">
                        <Card className="card-transparent shadow-none d-flex justify-content-center mb-0 auth-card">
                           <Card.Body>
                              <Link to="/" className="auth-brand-link navbar-brand d-flex align-items-center mb-3">
                                 <Logo />
                                 <h4 className="logo-title ms-3">Quizify</h4>
                              </Link>
                              <h2 className="mb-2 text-center">{t.auth.signInTitle}</h2>
                              <p className="text-center">{t.auth.signInSubtitle}</p>
                              <Form onSubmit={handleSubmit}>
                                 <Row>
                                    <Col lg="12">
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="email" className="">{t.auth.email}</Form.Label>
                                          <Form.Control type="email" className="" name="email" id="email" onChange={handleChange} aria-describedby="email" placeholder=" " required />
                                       </Form.Group >
                                    </Col>
                                    <Col lg="12" className="">
                                       <Form.Group className="form-group">
                                          <Form.Label htmlFor="password" className="">{t.auth.password}</Form.Label>
                                          <Form.Control type="password" className="" name="password" id="password" onChange={handleChange} aria-describedby="password" placeholder=" " required />
                                       </Form.Group>
                                    </Col>
                                    <Col lg="12" className="d-flex justify-content-between">
                                       <Form.Check className="form-check mb-3">
                                          <Form.Check.Input type="checkbox" name="remember" id="remember" onChange={handleChange}/>
                                          <Form.Check.Label htmlFor="remember">{t.auth.rememberMe}</Form.Check.Label>
                                       </Form.Check>
                                       <Link to="/recoverpw">{t.auth.forgotPassword}</Link>
                                    </Col>
                                 </Row>
                                 <div className="d-flex justify-content-center">
                                    <Button type="submit" variant="btn btn-primary">{t.auth.signInButton}</Button>
                                 </div>
                                 {/*
                                 <p className="text-center my-3">{t.auth.socialPrompt}</p>
                                 <div className="d-flex justify-content-center">
                                    <ListGroup as="ul" className="list-group-horizontal list-group-flush">
                                       <ListGroup.Item as="li" className="border-0 pb-0">
                                          <Link to="#"><Image src={facebook} alt="fb" /></Link>
                                       </ListGroup.Item>
                                       <ListGroup.Item as="li" className="border-0 pb-0">
                                          <Link to="#"><Image src={google} alt="gm" /></Link>
                                       </ListGroup.Item>
                                       <ListGroup.Item as="li" className="border-0 pb-0">
                                          <Link to="#"><Image src={instagram} alt="im" /></Link>
                                       </ListGroup.Item>
                                       <ListGroup.Item as="li" className="border-0 pb-0">
                                          <Link to="#"><Image src={linkedin} alt="li" /></Link>
                                       </ListGroup.Item>
                                    </ListGroup>
                                 </div>
                                 */}
                                 <p className="mt-3 text-center">
                                    {t.auth.noAccount} <Link to="/sign-up" className="text-underline">{t.auth.signUpLink}</Link>
                                 </p>
                              </Form>
                           </Card.Body>
                        </Card>
                     </Col>
                  </Row>
                  <div className="sign-bg">
                     <AuthDecor />
                  </div>
               </Col>
               <Col md="6" className="d-md-block d-none bg-primary p-0 mt-n1 vh-100 overflow-hidden">
                  <Image src={auth1} className="Image-fluid gradient-main animated-scaleX" alt="images" />
               </Col>
            </Row>
         </section>
      </>
   )
}

export default SignIn
